<template>
  <b-icon
    class="icon"
    :class="[iconNameClass]"
    :icon="name"
    :fill="color"
    :width="width"
    :height="height"
    @click="clicked"
  ></b-icon>
</template>

<script>
import Vue from "vue";

export default {
  name: "BaseIcon",
  props: {
    color: {
      type: String,
      default: "inherit"
    },
    name: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: "24"
    },
    height: {
      type: String,
      default: "24"
    }
  },
  computed: {
    iconNameClass() {
      return `icon-${this.name}`;
    }
  },
  methods: {
    clicked: function(e) {
      this.$emit("click", e);
    }
  }
};
</script>

<style>
.icon {
  display: inline;
  position: relative;
  top: 0;
  width: 1em;
  vertical-align: bottom;
}
</style>
